import { Platform, StyleSheet } from 'react-native';

import { Fonts } from 'assets/fonts';

import { COLOR, blackTransparent, lightGrey } from 'utils/colors';

const styles = StyleSheet.create({
    root: {
        flex: 1,
        backgroundColor: lightGrey(0.2),
        justifyContent: 'center',
        paddingLeft: Platform.select({
            web: 0,
            default: 6,
        }),
        borderRadius: 2,
    },
    webStickyText: {
        // @ts-ignore
        position: 'sticky',
        alignSelf: 'flex-start',
        left: 6,
    },
    playing: {
        backgroundColor: COLOR.primary,
    },
    boldText: {
        fontFamily: Fonts.main.bold,
    },
    unsubscribedOverlay: {
        ...StyleSheet.absoluteFillObject,
        backgroundColor: blackTransparent(0.5),
    },
});

export default styles;
